import './scss/Nav.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';

const navigation = [
  {
    name: 'EMS Dashboard',
    icon: <i className="fas fa-tachometer-alt"></i>,
    submenu: [
      {
        name: 'Main Panel',
        path: '/EMS/dashboard',
        icon: <i className="fas fa-columns"></i>,
      },
      {
        name: 'Custom Dashboard',
        path: '/EMS/custom-dashboard',
        icon: <i className="fas fa-th-large"></i>,
      },
      {
        name: 'Group Portal',
        path: '/EMS/group-portal',
        icon: <i className="fas fa-users-cog"></i>,
      },
      {
        name: 'TOD Readings',
        path: '/EMS/ActualReadingportal',
        icon: <i className="fas fa-users-cog"></i>,
      },
    ],
  },
  {
    name: 'EnPI Dashboard',
    icon: <i className="fas fa-industry"></i>,
    path: '/EMS/production',
  },
  {
    name: 'Water Flow',
    icon: <i className="fas fa-tint"></i>,
    path: '/EMS/flowportal',
  },
  {
    name: 'Level Dashboard',
    icon: <i className="fas fa-water"></i>,
    path: '/EMS/Levelportal',
  },
  {
    name: 'Production Data',
    icon: <i className="fas fa-tools"></i>,
    path: '/EMS/productiondetails',

      // {
      //   name: 'Colcks',
      //   path: '/EMS/clocks',

      // },
  },
  // {
  //   name: 'Production',
  //   icon: <i className="fas fa-tools"></i>,
  //   path: '/EMS/Productionnext',
  // },
  {
    name: 'Energy Source',
    icon: <i className="fas fa-battery-three-quarters"></i>,
    path: '/EMS/EnergySource',
  },
  {
    name: 'TOD Grid',
    icon: <i className="fas fa-book-open"></i>,
    path: '/EMS/Actualreading',
  },
  {
    name: 'Meter Config',
    icon: <i className="fas fa-bolt"></i>,
    submenu: [
      {
        name: 'Meter List',
        path: '/EMS/energymeter',

      },
      {
        name: 'EMS Groups',
        path: '/EMS/emsgroups',

      },
      {
        name: 'Peak Timings',
        path: '/EMS/peaktimings',
      },
      {
        name: 'Energy Data',
        path: '/EMS/energydata'
      },
      {
        name: 'Departments',
        path: '/EMS/machine',
      },
      {
        name: 'Products List',
        path: '/EMS/Products',
      },
    ],
  },
  {
    name: 'Flow Meter',
    icon: <i className="fas fa-project-diagram"></i>,
    submenu: [
      {
        name: 'Flow Meter List',
        path: '/EMS/flowmeter',

      },
      // {
      //   name: 'Flow Groups',
      //   path: '/EMS/flowgroup',

      // },
      {
        name: 'Level Meter',
        path: '/EMS/Levelmeter',
      },
    ],
  },
  {
    name: 'Reports',
    icon: <i className="fas fa-chart-line"></i>,
    submenu: [
      {
        name: 'Meter Reports',
        path: '/EMS/reports/',

      },
      {
        name: 'Production Reports',
        path: '/EMS/productionreports',

      },
      {
        name: 'Alert Reports',
        path: '/EMS/alertreports',

      },
      {
        name: 'TOD Grid Reports',
        path: '/EMS/Readingreport',

      },
      {
        name: 'Flow Reports',
        path: '/EMS/Flowreport',

      },
      {
        name: 'Level Reports',
        path: '/EMS/Levelreport',

      },
    ],
  },
  {
    name: 'Schedules',
    path: '/EMS/Schedules',
    icon: <i className="fas fa-cog"></i>,
  },
  {
    name: 'Rule Engine',
    icon: <i className="fas fa-exclamation-circle"></i>,
    path: '/EMS/alerts',
  },

  {
    name: 'Settings',
    path: '/EMS/alertssettings',
    icon: <i className="fas fa-cog"></i>,
  },


  {
    name: 'User List',
    path: '/EMS/usersgroups',
    icon: <i className="fas fa-user"></i>,
  },
  {
    name: 'User Group',
    path: '/EMS/usergroup',
    icon: <i className="fas fa-layer-group"></i>,
  },
  // {
  //   name: 'Settings',
  //   path: '/EMS/settings',
  //   icon: <i className="fas fa-gear"></i>,
  // },

];

export default navigation;
